import script from "./TourSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./TourSearch.vue?vue&type=script&setup=true&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__